import React, { Component } from 'react'

import Datepicker from '../datepicker'

import Typeahead from '../typeahead'

import moment from 'moment'

import {
  StyledDateSelectorContainer
} from './Dateselector.styles'

export default class DateSelectorContainer extends Component {
  constructor(props) {
    super(props)

    moment.locale('en')

    const placeholderText = this.props.placeholderText
      ? this.props.placeholderText
      : 'Select Date'

    const selectedValue = this.props.selectedValue ? this.props.selectedValue : placeholderText
    let range = false
    let showSingleDatepicker = false
    let showRangeDatepicker = false
    let date = this.props.date || undefined
    let fromDate = this.props.fromDate || undefined
    let toDate = this.props.toDate || undefined

    if (selectedValue === 'today') {
      showSingleDatepicker = true
      date = moment()
    } else if (selectedValue === 'dateSingle') {
      // date = undefined
      showSingleDatepicker = true
    } else if (selectedValue === '7') {
      range = true
      fromDate = moment().subtract(7, 'd')
      toDate = moment()
      showRangeDatepicker = true
    } else if (selectedValue === '30') {
      range = true
      fromDate = moment().subtract(30, 'd')
      toDate = moment()
      showRangeDatepicker = true
    } else if (selectedValue === 'week') {
      range = true
      fromDate = moment().startOf('week')
      if (this.props.datePicker.preventFutureDates) {
        toDate = moment()
      } else {
        toDate = moment().endOf('week')
      }
      showRangeDatepicker = true
    } else if (selectedValue === 'month') {
      range = true
      fromDate = moment().startOf('month')
      if (this.props.datePicker.preventFutureDates) {
        toDate = moment()
      } else {
        toDate = moment().endOf('month')
      }
      showRangeDatepicker = true
    } else if (selectedValue === 'dateRange') {
      range = true
      // fromDate = undefined
      // toDate = undefined
      showSingleDatepicker = false
      showRangeDatepicker = true
    } else if (selectedValue === placeholderText) {
      date = undefined
      fromDate = undefined
      toDate = undefined
    }

    this.state = {
      showSingleDatepicker,
      showRangeDatepicker,
      range,
      date,
      fromDate,
      toDate,
      selectedValue,
      placeholderText,
      error: {}
    }
  }

  componentWillReceiveProps(newProps) {
    moment.locale('en')

    const placeholderText = newProps.placeholderText
      ? newProps.placeholderText
      : 'Select Date'

    const selectedValue = newProps.selectedValue ? newProps.selectedValue : placeholderText
    let range = false
    let showSingleDatepicker = false
    let showRangeDatepicker = false
    let date = newProps.date || undefined
    let fromDate = newProps.fromDate || undefined
    let toDate = newProps.toDate || undefined

    if (selectedValue === 'today') {
      showSingleDatepicker = true
      date = moment()
    } else if (selectedValue === 'dateSingle') {
      showSingleDatepicker = true
    } else if (selectedValue === '7') {
      range = true
      fromDate = moment().subtract(7, 'd')
      toDate = moment()
      showRangeDatepicker = true
    } else if (selectedValue === '30') {
      range = true
      fromDate = moment().subtract(30, 'd')
      toDate = moment()
      showRangeDatepicker = true
    } else if (selectedValue === 'week') {
      range = true
      fromDate = moment().startOf('week')
      if (this.props.datePicker.preventFutureDates) {
        toDate = moment()
      } else {
        toDate = moment().endOf('week')
      }
      showRangeDatepicker = true
    } else if (selectedValue === 'month') {
      range = true
      fromDate = moment().startOf('month')
      if (this.props.datePicker.preventFutureDates) {
        toDate = moment()
      } else {
        toDate = moment().endOf('month')
      }
      showRangeDatepicker = true
    } else if (selectedValue === 'dateRange') {
      range = true
      showSingleDatepicker = false
      showRangeDatepicker = true
    } else if (selectedValue === placeholderText) {
      date = undefined
      fromDate = undefined
      toDate = undefined
    }

    this.setState({
      showSingleDatepicker,
      showRangeDatepicker,
      range,
      date,
      fromDate,
      toDate,
      selectedValue,
      placeholderText,
      error: {}
    })
  }

  handleDateChange = (date, error) => {
    const { dateSelectorCallBack, handleDateSelector } = this.props
    // if (moment(date).format(this.props.datePicker.dateFormat) !== moment().format(this.props.datePicker.dateFormat)) {

    const state = this.state

    state.selectedValue = 'dateSingle'
    state.date = date
    state.error = error
    this.setState(state)

    if (dateSelectorCallBack && window.TR_pageFunctions[dateSelectorCallBack]) {
      window.TR_pageFunctions[dateSelectorCallBack](this.state)
    }

    if (handleDateSelector) {
      handleDateSelector(this.state)
    }
    // }
  }

  handleDateRangeFromDateChange = (fromDate, toDate, error) => {
    const { dateSelectorCallBack, handleDateSelector } = this.props

    if (moment(fromDate).format(this.props.datePicker.dateFormat) !== moment(this.state.fromDate).format(this.props.datePicker.dateFormat) ||
        moment(toDate).format(this.props.datePicker.dateFormat) !== moment(this.state.toDate).format(this.props.datePicker.dateFormat)) {

      const state = this.state

      state.selectedValue = 'dateRange'
      state.fromDate = fromDate
      state.toDate = toDate
      state.error = error
      this.setState(state)
    }

    if (dateSelectorCallBack && window.TR_pageFunctions[dateSelectorCallBack]) {
      window.TR_pageFunctions[dateSelectorCallBack](this.state)
    }

    if (handleDateSelector) {
      handleDateSelector(this.state)
    }
  }

  handleDateRangeToDateChange = (toDate, fromDate, error) => {
    const { dateSelectorCallBack, handleDateSelector } = this.props

    if (moment(toDate).format(this.props.datePicker.dateFormat) !== moment(this.state.toDate).format(this.props.datePicker.dateFormat) ||
        moment(fromDate).format(this.props.datePicker.dateFormat) !== moment(this.state.fromDate).format(this.props.datePicker.dateFormat) || 
        this.state.toDate === undefined || 
        error.message.trim().length > 0) {

      const state = this.state

      state.selectedValue = 'dateRange'
      state.toDate = toDate
      state.fromDate = fromDate
      state.error = error
      this.setState(state)
    }

    if (dateSelectorCallBack && window.TR_pageFunctions[dateSelectorCallBack]) {
      window.TR_pageFunctions[dateSelectorCallBack](this.state)
    }

    if (handleDateSelector) {
      handleDateSelector(this.state)
    }
  }

  showDatePicker = (e) => {
    const config = {
      preventFutureDates: this.props.datePicker.preventFutureDates,
      placeholder: this.props.datePicker.Dateplaceholder,
      fromPlaceholder: this.props.datePicker.Dateplaceholder,
      toPlaceholder: this.props.datePicker.Dateplaceholder,
      datePickerFromName: this.props.datePicker.datePickerFromName,
      datePickerToName: this.props.datePicker.datePickerToName,
      datePickerName: this.props.datePicker.datePickerName,
      locale: this.props.datePicker.locale,
      dateSingleCallBack: this.props.datePicker.dateSingleCallBack,
      dateRangeFromCallBack: this.props.datePicker.dateRangeFromCallBack,
      dateRangeToCallBack: this.props.datePicker.dateRangeToCallBack,
      dateFormat: this.props.datePicker.dateFormat,
      todayLink: this.props.datePicker.todayLink,
      i18n: {
        select_from_date: this.props.datePicker.i18n.select_from_date,
        select_to_date: this.props.datePicker.i18n.select_to_date,
        invalid_from_date: this.props.datePicker.i18n.invalid_from_date,
        invalid_to_date: this.props.datePicker.i18n.invalid_to_date,
        invalid_date_range: this.props.datePicker.i18n.invalid_date_range,
        invalid_from_future_date: this.props.datePicker.i18n.invalid_from_future_date,
        invalid_to_future_date: this.props.datePicker.i18n.invalid_to_future_date,
        invalid_date: this.props.datePicker.i18n.invalid_date,
        invalid_future_date: this.props.datePicker.i18n.invalid_future_date
      },
      range: this.state.range,
      date: this.state.date,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      handleDateChange: this.handleDateChange,
      handleToDateChange: this.handleDateRangeToDateChange,
      handleFromDateChange: this.handleDateRangeFromDateChange
    }

    return <Datepicker {...config} />
  }

  setStateForDateSelector = (selectedValue) => {
    moment.locale('en')

    const state = this.state

    state.error = {}
    state.selectedValue = selectedValue
    if (selectedValue === 'today') {
      state.range = false
      state.date = moment().toDate()
      state.showSingleDatepicker = true
      state.showRangeDatepicker = false
    } else if (selectedValue === 'dateSingle') {
      state.range = false
      state.date = undefined
      state.showSingleDatepicker = true
      state.showRangeDatepicker = false
    } else if (selectedValue === '7') {
      state.range = true
      state.fromDate = moment().subtract(7, 'd').toDate()
      state.toDate = moment().toDate()
      state.showSingleDatepicker = false
      state.showRangeDatepicker = true
    } else if (selectedValue === '30') {
      state.range = true
      state.fromDate = moment().subtract(30, 'd').toDate()
      state.toDate = moment().toDate()
      state.showSingleDatepicker = false
      state.showRangeDatepicker = true
    } else if (selectedValue === 'week') {
      state.range = true
      state.fromDate = moment().startOf('week').toDate()
      if (this.props.datePicker.preventFutureDates) {
        state.toDate = moment().toDate()
      } else {
        state.toDate = moment().endOf('week').toDate()
      }
      state.showSingleDatepicker = false
      state.showRangeDatepicker = true
    } else if (selectedValue === 'month') {
      state.range = true
      state.fromDate = moment().startOf('month').toDate()
      if (this.props.datePicker.preventFutureDates) {
        state.toDate = moment().toDate()
      } else {
        state.toDate = moment().endOf('month').toDate()
      }
      state.showSingleDatepicker = false
      state.showRangeDatepicker = true
    } else if (selectedValue === 'dateRange') {
      state.range = true
      state.fromDate = undefined
      state.toDate = undefined
      state.showSingleDatepicker = false
      state.showRangeDatepicker = true
    } else {
      state.range = false
      state.date = undefined
      state.fromDate = undefined
      state.toDate = undefined
      state.showSingleDatepicker = false
      state.showRangeDatepicker = false
    }
    this.setState(state)
  }

  showTypeaheadAsMultiHeaderDropdown = (e) => {
    const { dateSelectorCallBack, handleDateSelector } = this.props
    const config = {
      name: this.props.name,
      multiheaderEnabled: true,
      noResultsFoundText: 'We are sorry. This filter cannot be used',
      selectedValue: this.state.selectedValue,
      placeholderText: this.state.placeholderText,
      headers: this.props.headers
    }

    return <Typeahead {...config} onChange={(selectedValue) => {
      this.setStateForDateSelector(selectedValue)

      if (dateSelectorCallBack && window.TR_pageFunctions[dateSelectorCallBack]) {
        window.TR_pageFunctions[dateSelectorCallBack](this.state)
      }

      if (this.props.handleDateSelector) {
        handleDateSelector(this.state)
      }
    }} />
  }

  render() {
    const {
      showSingleDatepicker,
      showRangeDatepicker
    } = this.state

    return (
      <StyledDateSelectorContainer data-testid='StyledDateSelectorContainer'>
        {
          this.showTypeaheadAsMultiHeaderDropdown()
        }
        { (showSingleDatepicker || showRangeDatepicker) &&
          this.showDatePicker()
        }
      </StyledDateSelectorContainer>
    )
  }
}
